/** ローディング画面（地形生成の進捗） */
import { el } from '../layout';

export interface LoadingScreen {
  setProgress(label: string, fraction: number): void;
  showError(message: string): void;
  hide(): void;
}

export function createLoadingScreen(host: HTMLElement): LoadingScreen {
  const root = el('div', 'loading');
  const title = el('h1', 'loading__title', 'ALPINE TRAVERSE');
  const sub = el('p', 'loading__sub', 'アルプスを生成しています');
  const bar = el('div', 'loading__bar');
  const fill = el('div', 'loading__fill');
  const label = el('p', 'loading__label', '準備中');
  bar.appendChild(fill);
  root.append(title, sub, bar, label);
  host.appendChild(root);

  return {
    setProgress(text, fraction) {
      fill.style.width = `${Math.round(fraction * 100)}%`;
      label.textContent = text;
    },
    showError(message) {
      sub.textContent = '生成に失敗しました';
      label.textContent = message;
      root.classList.add('loading--error');
    },
    hide() {
      root.classList.add('loading--done');
      setTimeout(() => root.remove(), 600);
    },
  };
}
